/**
 * Rotas que funcionam SEM sessão de organizador.
 *
 * Existe porque o app do participante (`/app`) mora na mesma SPA do painel, e o
 * painel monta `AuthProvider` + `EventProvider` na raiz (`App.tsx`). Esses dois
 * buscam `/api/me` e `/api/eventos/ativo` assim que a app sobe; num visitante
 * público as duas chamadas voltam 401, e o handler global de 401 mandava a
 * pessoa para a tela de login — a rota respondia 200 no servidor e mesmo assim
 * ninguém conseguia usar o chat.
 *
 * Fonte única: `AuthContext` e `EventContext` consultam daqui para não buscar
 * nada, e para não redirecionar, quando o visitante está numa destas rotas.
 *
 * Caminhos SEM o basename `/ui` — é o que `useLocation().pathname` devolve.
 */
export const ROTAS_PUBLICAS = ["/app"] as const;

/** True quando o caminho atual dispensa sessão (a rota exata ou algo abaixo dela). */
export function ehRotaPublica(pathname: string): boolean {
  return ROTAS_PUBLICAS.some((rota) => pathname === rota || pathname.startsWith(`${rota}/`));
}
